"use client";

import { useState, useEffect } from "react";
import { Heading } from "@/components/Heading";
import * as prismic from "@prismicio/client";
import { PrismicRichText } from "@/components/PrismicRichText";

const PageWithSummary = ({ slice }) => {
  const termsSections = slice.primary.sections;
  const [activeSection, setActiveSection] = useState(termsSections[0].anchor);

  return (
    <section className="mx-auto bg-seashell rounded-md py-10">
      <div className="flex flex-col md:flex-row p-6 max-w-7xl mx-auto">
        {/* Sidebar Navigation */}
        <nav className="md:w-1/3 mb-6 md:mb-0 md:pr-6 border-r hidden md:block">
          <ul className="sticky top-40">
            {termsSections.map((section, index) => (
              <li key={index}>
                <a
                  href={`#${section.anchor}`}
                  className={`font-serif block text-black text-lg hover:bg-white font-medium border-gray-200/80 p-2 transition-colors duration-300 ${
                    index === 0 ? "" : "border-t"
                  } ${index === termsSections.length - 1 ? "" : "border-b"} ${
                    activeSection === section.anchor ? "bg-white" : ""
                  }`}
                  onClick={() => setActiveSection(section.anchor)}
                >
                  {index + 1}. {prismic.asText(section.title)}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div className="md:w-2/3 space-y-8 px-6">
          {termsSections.map((section, index) => (
            <section id={section.anchor} key={index} className="scroll-mt-32">
              <Heading as="h2" size="3xl" className="mb-4">
                {index + 1}. {prismic.asText(section.title)}
              </Heading>
              <div className="font-sans mb-20">
                <PrismicRichText field={section.content} />
              </div>
            </section>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PageWithSummary;
